import type { LabV2Snackbar } from 'lib/labV2/snackbars'
import { popupSeenUntil } from 'lib/labV2/popups'
import { isExpiringDismissalActive, setExpiringDismissal } from './expiringDismissalEntry'

const KEY_PREFIX = 'labV2Snackbar:'

function storageKey(id: number) {
  return `${KEY_PREFIX}${id}`
}

export function isLabV2SnackbarSuppressed(snackbar: LabV2Snackbar): boolean {
  return isExpiringDismissalActive(storageKey(snackbar.id))
}

export function recordLabV2SnackbarSeen(snackbar: LabV2Snackbar, now = new Date()) {
  setExpiringDismissal(storageKey(snackbar.id), popupSeenUntil(snackbar.displayFrequency, now))
}
